export const ON_POST_LEARNING_APP_MESSAGE_SUBSCRIPTION = `
  subscription onPostLearningAppMessage($studentId: ID!) {
    onPostLearningAppMessage(studentId: $studentId) {
      createdOn
      payload
      id
      messageType
      studentId
      learningAppId
    }
  }
`;
